import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_LifecycleStatusFilter = _resolveComponent("LifecycleStatusFilter")!
  const _component_PlatformCategoryDropdown = _resolveComponent("PlatformCategoryDropdown")!

  return (_openBlock(), _createBlock(_component_PlatformCategoryDropdown, {
    platform: _ctx.platform,
    categories: _ctx.categories,
    "is-active": _ctx.isActive,
    "all-selected": _ctx.allSelected,
    "selected-category-ids": _ctx.selectedCategoryIds,
    onTogglePlatform: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-platform'))),
    onToggleAll: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-all-categories'))),
    onToggleCategory: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle-category', $event)))
  }, _createSlots({ _: 2 }, [
    (_ctx.hasLifecycle)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createVNode(_component_q_separator),
            _createVNode(_component_LifecycleStatusFilter, {
              "model-value": _ctx.selectedLifecycleStatuses,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('lifecycle-change', $event)))
            }, null, 8, ["model-value"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["platform", "categories", "is-active", "all-selected", "selected-category-ids"]))
}